import { render, staticRenderFns } from "./TeleMarketSmsTemplate.vue?vue&type=template&id=14be0818&scoped=true"
import script from "./TeleMarketSmsTemplate.vue?vue&type=script&lang=js"
export * from "./TeleMarketSmsTemplate.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketSmsTemplate.vue?vue&type=style&index=0&id=14be0818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14be0818",
  null
  
)

export default component.exports